/*eslint-disable*/
//@ts-nocheck
import dayjs from 'dayjs';
import { memo } from 'react';

import { Badge, Box, Flex, Group, LoadingOverlay, ScrollArea, Table, Text } from '@mantine/core';

import { useQuery } from '@tanstack/react-query';

import { selectPersonId } from '@/store/user-process/user-selectors';

import { UserRating } from '@/entities/User';

import { ratingApi } from '@/shared/api/rating';
import { TRatingBookingType } from '@/shared/types/rating.types';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

import { useAppSelector } from '@/hooks';

const ratedBookingType: Record<TRatingBookingType, string> = {
	active: 'Активная',
	cancelled: 'Отмененная',
};

const Rating = () => {
	const personId = useAppSelector(selectPersonId);

	const { data: rating, isLoading: isRatingLoading } = useQuery({
		queryKey: ['ratingDetail'],
		queryFn: () => ratingApi.getPersonRatingDetail(personId!),
		enabled: !!personId,
	});

	const rows = rating?.rated_bookings
		.sort((a, b) => dayjs(b.booking.start).unix() - dayjs(a.booking.start).unix())
		.map((rated) => (
			<Table.Tr key={rated.id}>
				<Table.Td>
					<Text size="lg" fw={600} lts="normal">
						{rated.booking.booking_object.name.replace(/\s\|\s[\d\D]+/gm, '')}
					</Text>
				</Table.Td>
				<Table.Td>
					<Text size="md" c="dimmed">
						{rated.booking.booking_object.description}
					</Text>
				</Table.Td>
				<Table.Td ta="center">
					<Text size="md" c="dimmed">
						{rated.booking.car_number}
					</Text>
				</Table.Td>
				<Table.Td ta="center">
					<Text size="md" c="dimmed">
						{dayjs(rated.booking.start).format('DD MMMM HH:mm')}
					</Text>

					<Text size="md" c="dimmed">
						{dayjs(rated.booking.end).format('DD MMMM HH:mm')}
					</Text>
				</Table.Td>
				<Table.Td ta="center">
					<Text size="md" c="dimmed">
						{rated.booking_type === 'active' ? `${Math.round(rated.value)}%` : ''}
					</Text>
				</Table.Td>
				<Table.Td ta="center">
					<Text size="md" c="dimmed">
						{rated.booking_type === 'cancelled' ? `${Math.round(rated.value)}%` : ''}
					</Text>
				</Table.Td>
				<Table.Td>
					<Badge variant="light" color={rated.booking_type === 'active' ? 'green' : 'red'}>
						{ratedBookingType[rated.booking_type]}
					</Badge>
				</Table.Td>
			</Table.Tr>
		));

	return (
		<LayoutRow
			title={{
				title: { children: 'Мой рейтинг', size: 'h4', fw: 800 },
			}}
			type="once"
			style={{ height: 'calc(100vh - 116px)' }}
		>
			<Box pos="relative" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
				<LoadingOverlay
					visible={isRatingLoading}
					zIndex={1000}
					overlayProps={{ radius: 2, blur: 2 }}
				/>
				<Group>
					<UserRating />
				</Group>
				{rating && rating.rated_bookings.length > 0 ? (
					<ScrollArea h={'100dvh'} pr={'md'} scrollbarSize={12} offsetScrollbars>
						<Table verticalSpacing="sm" stickyHeader>
							<Table.Thead>
								<Table.Tr>
									<Table.Th>
										<Text size="md" c="dimmed">
											Название
										</Text>
									</Table.Th>
									<Table.Th>
										<Text size="md" c="dimmed">
											Описание
										</Text>
									</Table.Th>
									<Table.Th ta="center">
										<Text size="md" c="dimmed">
											Номер авто
										</Text>
									</Table.Th>
									<Table.Th ta="center">
										<Text size="md" c="dimmed">
											Дата
										</Text>
									</Table.Th>

									<Table.Th w="10%" ta="center">
										<Text size="md" c="dimmed">
											Коэффициент использования
										</Text>
									</Table.Th>

									<Table.Th w="10%" ta="center">
										<Text size="md" c="dimmed">
											Коэффициент отмены
										</Text>
									</Table.Th>

									<Table.Th>
										<Text size="md" c="dimmed">
											Статус
										</Text>
									</Table.Th>
								</Table.Tr>
							</Table.Thead>
							<Table.Tbody>{rows}</Table.Tbody>
						</Table>
					</ScrollArea>
				) : (
					<Flex direction="column" align="center" justify="center" h={'calc(100vh - 300px)'}>
						<Text fz={18} fw={700}>
							Пока ничего нет 😔
						</Text>
					</Flex>
				)}
			</Box>
		</LayoutRow>
	);
};

export default memo(Rating);
